
export class DeletePropertyExpenseRequest{
    public userId!:string;
    public businessId!:string;
    public propertyExpenseId!:number;
}